import { computed } from 'vue';
import { type RouteRecordRaw } from 'vue-router';

import { useGlobalI18n } from '@abaninja/util-i18n';

const { global: { t } } = useGlobalI18n();

export const routes: RouteRecordRaw[] = [
  {
    path: 'support',
    children: [
      {
        name: 'support',
        path: '',
        component: () => import('../SupportIndex.vue'),
      },
      {
        name: 'support-info',
        path: 'info',
        component: () => import('../SupportInfoIndex.vue'),
      },
      {
        path: 'ticket',
        children: [
          {
            name: 'support-ticket',
            path: '',
            component: () => import('../SupportTicketIndex.vue'),
          },
          {
            name: 'support-ticket-success',
            path: 'success',
            component: () => import('../SupportTicketSuccess.vue'),
          },
        ],
      },

    ],
    meta: {
      title: computed(() => t('messages.support')),
    },
  },
];
